import { render, staticRenderFns } from "./FinalizacaoDetalhesComprador.vue?vue&type=template&id=690e75e2"
import script from "./FinalizacaoDetalhesComprador.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDetalhesComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports